import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";

import type { RootContext } from "@/config/router";

const RootComponent = () => {
  return (
    <>
      <a
        className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-50 focus:rounded-full focus:bg-surface-inverted focus:px-5 focus:py-3 focus:font-semibold focus:text-content-on-inverted"
        href="#main-content"
      >
        Skip to main content
      </a>

      <Outlet />
    </>
  );
};

export const Route = createRootRouteWithContext<RootContext>()({ component: RootComponent });
